<template>
  <div class="control-panel">
    <InviteModal :active="inviteModal" @toggle="inviteModalToggle(false)" />
    <SignupForm :active="signUpModal" @toggle="signUpModalToggle(false)" />
    <control-panel v-if="true" title="Usuarios">
      <template v-slot:actions>
        <SearchBar @search="(e) => serachItem(e)" @clear="clearSearch()" placeHolder="" />

        <div class="ml-md-5 ml-lg-5 ml-sm-2 ml-0 mb-2 control-panel-actions">
          <v-menu :close-on-content-click="false" offset-y left rounded="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="v-btn--primary control-panel-actions" v-bind="attrs" v-on="on">
                <v-icon class="mr-2">mdi-account-plus</v-icon> Añadir Usuario
              </v-btn>
            </template>

            <v-list class="list">
              <v-list-item class="list--item" v-for="(item, i) in userOptions" :key="i" @click="item.action" dense>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </control-panel>
    <template v-if="true">
      <div class="action-wrapper">


      </div>
    </template>
  </div>
</template>

<script>
import SearchBar from "./SearchBar.vue";
import SignupForm from "../Form/SignupForm.vue";
import InviteModal from "../Users/InviteModal.vue";
import ControlPanel from "@/Shared/ControlPanel";
export default {
  data() {
    return {
      signUpModal: false,
      inviteModal: false,
      userOptions: [
        {
          title: "Registrar",
          icon: "mdi-plus",
          action: () => this.signUpModalToggle(true),
        },
        {
          title: "Invitar",
          icon: "mdi-email-send",
          action: () => this.inviteModalToggle(true),
        },
      ],
    };
  },
  components: {ControlPanel, SearchBar, SignupForm, InviteModal },
  methods: {
    signUpModalToggle(value) {
      this.signUpModal = value;
    },
    inviteModalToggle(value) {
      this.inviteModal = value;
    },
    invite() {
      /**/
    },
  },
};
</script>
